/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePasswordCommand
 */
export interface UpdatePasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordCommand
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordCommand
     */
    newPassword: string;
}

export function UpdatePasswordCommandFromJSON(json: any): UpdatePasswordCommand {
    return UpdatePasswordCommandFromJSONTyped(json, false);
}

export function UpdatePasswordCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePasswordCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentPassword': json['currentPassword'],
        'newPassword': json['newPassword'],
    };
}

export function UpdatePasswordCommandToJSON(value?: UpdatePasswordCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currentPassword': value.currentPassword,
        'newPassword': value.newPassword,
    };
}

